<template>
  <nav class="navbar">
    <div class="container">
      <div class="brand">加恒科技</div>
      <ul class="links">
        <li><a href="#hero">首页</a></li>
        <li><a href="#features">特点</a></li>
        <li><a href="#showcase">展示</a></li>
        <li><a href="#enterprise">企业</a></li>
        <li><a href="#legal">合规</a></li>
        <li><a href="#pricing">价格</a></li>
        <li><a href="#faq">常见问题</a></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar'
}
</script>

<style scoped>
.navbar {
  position: sticky;
  top: 0;
  background: #0f172a;
  color: #e2e8f0;
  z-index: 50;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.container {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}
.brand {
  font-weight: 700;
  letter-spacing: 0.4px;
}
.links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 18px;
}
.links a {
  color: inherit;
  text-decoration: none;
  opacity: 0.9;
}
.links a:hover {
  opacity: 1;
}
@media (max-width: 640px) {
  .links {
    display: none;
  }
}
</style>


